/**
 * 嵌套页面IFrame模块
 */

import { zuul } from '@/utils/global.js'

/**
 * 嵌套页面URL地址
 * @param {*} url
 */
export function getIFramePath (url) {
  let iframeUrl = ''
  if(/^iframe:.*/.test(url)) {
    iframeUrl = url.replace('iframe:', '')
  } else if(/^http[s]?:\/\/.*/.test(url)) {
    iframeUrl = url.replace('http://', '')
    iframeUrl = url.replace('https://', '')
    if(iframeUrl.indexOf(":") != -1) {
      iframeUrl = encodeURIComponent(iframeUrl.substring(iframeUrl.lastIndexOf(":") + 1))
    }
  }
  return iframeUrl
}

/**
 * 嵌套页面路由路径
 * @param {*} url
 */
export function getIFrameUrl (url) {
  let iframeUrl = ''
  if(/^iframe:.*/.test(url)) {
    iframeUrl = zuul + url.replace('iframe:', '')
  } else if(/^http[s]?:\/\/.*/.test(url)) {
    iframeUrl = url
  }
  return iframeUrl
}




// WEBPACK FOOTER //
// ./src/utils/iframe.js